export default __webpack_public_path__ + "static/media/home-top2.c221dde3.jpg";